module.exports = __webpack_public_path__ + "media/images/flags/1x1/ben-eb678983d015c32396a803021d556442.svg";